(function($){
    Application.searchAjax = {
        ui: {
            search: '.js-blog-search',
            contentProducts: '.js-ajax-content-products',
            contentBlog:'.js-ajax-content-blog',
            articleScreen: '.js-article',
            paginationBlog: '.js-pagination-blog',
            paginationProducts: '.js-pagination-products'
        },
        ready: function () {

            this.bind();
            var $search = $('.search-field').eq(1).val();
            this.search($search, 'prodcat');
            this.search($search, 'post');

        },
        bind: function () {

            var self = this;


            document.dataCurrentPageProducts = 1;
            document.dataCurrentPageBlog = 1;


        },
        resetPagination: function(){
            document.dataCurrentPageProducts = 1;
            document.dataCurrentPageBlog = 1;
        },

        search: function ($search, $postType) {
            if($postType == 'post') {
                var content = $(this.ui.contentBlog);
                var paginationElem = $(this.ui.paginationBlog);
                var CurrentPage = document.dataCurrentPageBlog;
                var templateXRender = '#ajaxSearchBlogPostsTemplate';
            }else{
                var content = $(this.ui.contentProducts);
                var paginationElem = $(this.ui.paginationProducts);
                var CurrentPage = document.dataCurrentPageProducts;
                var templateXRender = '#ajaxSearchProductsTemplate';
            }
            content.empty();
            paginationElem.empty();
            content.append('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');
            $.ajax({
                type: 'POST',
                url: link.ajax,
                data: {
                    'dataCurrentPage': CurrentPage,
                    'search': $search,
                    'postType': $postType,
                    'action': 'f001_search_blog_callback'
                },
                success: function (response) {
                    if(response.length == 0){
                        var tmpl = $.templates('#ajaxEmptySearchTemplate');
                        var $html = tmpl.render();
                        content.html($html);
                    }else {
                        content.empty();

                        $.each(response, function (key, value) {
                            var tmpl = $.templates(templateXRender);
                            if($postType == 'post') {
                                var data = {
                                    id: value.id,
                                    image: value.image,
                                    title: value.title,
                                    url: value.url,
                                    text: value.text
                                };
                            }else{
                                var data = {
                                    id: value.id,
                                    title: value.title,
                                    image: value.image,
                                    icon: value.icon,
                                    url: value.url
                                };
                            }
                            var $html = tmpl.render(data);
                            content.html(content.html() + $html);
                        });
                        if($postType == 'post'){
                            paginationBlog(response[0].pageCount, response[0].currentPage, response[0].postCount);
                        }else{
                            paginationProducts(response[0].pageCount, response[0].currentPage, response[0].postCount);
                        }
                    }
                },
                error: function () {
                    console.log("error");
                }
            });
        }
    };

    function paginationBlog(pageCount,currentPage,postCount){

        if(pageCount === 1){
            return;
        }else if(pageCount > 1){
            $('.js-pagination-blog').pagination({
                currentPage: currentPage,
                items: postCount,
                itemsOnPage: 6,
                cssStyle: 'light-theme',
               /* prevText: '',
                nextText: '',*/
                onPageClick: function(pageNumber) {
                    document.dataCurrentPageBlog = pageNumber;
                        var $search = $('.search-field').eq(1).val();
                        Application.searchAjax.search($search, 'post');
                }
            });
        }

    }

    function paginationProducts(pageCount,currentPage,postCount){

        if(pageCount === 1){
            return;
        }else if(pageCount > 1){
            $('.js-pagination-products').pagination({
                currentPage: currentPage,
                items: postCount,
                itemsOnPage: 6,
                cssStyle: 'light-theme',
                prevText: '<i class="icon-chevron-left"></i>',
                nextText: '<i class="icon-chevron-right"></i>',
                onPageClick: function(pageNumber) {
                    document.dataCurrentPageProducts = pageNumber;
                    var $search = $('.search-field').eq(1).val();
                    Application.searchAjax.search($search, 'prodcat');
                }
            });
        }

    }

    /* Forms */
    // submit
    $('.js-submit').click(function(e){
        e.preventDefault();
        $(this).closest('form').submit();
    });

    // search form - require query text
    $('.js-search-form').submit(function(e){
        var query = $(this).find('[name="s"]').val();
        if (!query){
            e.preventDefault();
        }
    });
})(jQuery);